var map = {
	"./Brand1.JPG": 2368,
	"./Brand2.JPG": 6292,
	"./Brand3.JPG": 9137,
	"./Brand4.JPG": 5106,
	"./Bus1.jpg": 4995,
	"./Bus2.jpg": 9540,
	"./Bus3.jpg": 8065,
	"./Bus4.jpg": 5154,
	"./Business1.JPG": 7728,
	"./Business2.jpeg": 7675,
	"./Business3.JPG": 3826,
	"./Business4.JPG": 8881,
	"./Business5.JPG": 3316,
	"./CM1.jpg": 1007,
	"./CM2.jpg": 6048,
	"./CM3.jpg": 9501,
	"./CM4.jpg": 6150,
	"./Ele_1.jpg": 1634,
	"./Ele_2.jpg": 1533,
	"./Elec1.JPG": 4795,
	"./Elec2.JPG": 2364,
	"./Hack-1-25.jpg": 7875,
	"./Hack-2-25.jpg": 4550,
	"./Hack-3-25.jpg": 5885,
	"./Hack-4-25.jpg": 4016,
	"./Hack-5-25.jpg": 4591,
	"./Hack-6-25.jpg": 2754,
	"./Hack-7-25.jpg": 7337,
	"./M-M1.JPG": 2863,
	"./M-M2.JPG": 8128,
	"./M1.jpg": 4486,
	"./M2.jpg": 4097,
	"./Moc1.jpg": 3524,
	"./Moc2.jpg": 1651,
	"./Moc3.jpg": 9478,
	"./Moc4.jpg": 925,
	"./Mock1.JPG": 196,
	"./Mock2.JPG": 2771,
	"./Mys1.jpg": 3710,
	"./Mys2.jpg": 2377,
	"./Mys3.jpg": 8028,
	"./Mys4.jpg": 2439,
	"./Sem-20-2026-1.1.jpeg": 8689,
	"./Sem-20-2026-1.2.JPG": 5978,
	"./Sem-20-2026-1.3.JPG": 4887,
	"./Sem-20-2026-1.4.jpg": 553,
	"./Sem-20-2026-1.5.jpg": 2508,
	"./Sem-20-2026-2.1.jpeg": 8348,
	"./Sem-20-2026-2.2.jpg": 7684,
	"./Sem-20-2026-2.3.jpg": 2017,
	"./Sem-20-2026-2.4.jpg": 3762,
	"./Sem-20-2026-2.5.jpg": 5471,
	"./Sem-20-2026-2.6.jpg": 1120,
	"./Sem-20-2026-3.1.jpeg": 1303,
	"./Sem-20-2026-3.2.jpg": 4405,
	"./Sem-20-2026-3.3.JPG": 4997,
	"./Sem-20-2026-3.4.jpg": 3179,
	"./Sem-20-2026-3.5.jpg": 7342,
	"./Sem-20-2026-4.1.jpeg": 4978,
	"./Sem-20-2026-4.2.jpg": 770,
	"./Sem-20-2026-4.3.jpg": 3151,
	"./Sem-20-2026-4.4.jpg": 8212,
	"./Sem-20-2026-4.5.jpg": 6257,
	"./Sem-20-2026-5.1.jpeg": 4829,
	"./Sem-20-2026-5.2.jpg": 147,
	"./Sem-20-2026-5.3.jpg": 8534,
	"./Sem-20-2026-5.4.jpg": 5405,
	"./Sem-20-2026-5.5.JPG": 1829,
	"./Sem-20-2026-5.6.jpg": 6479,
	"./Sem-20-2026-5.7.jpg": 6450,
	"./Sem1_1.jpg": 1770,
	"./Sem1_2.jpg": 2002,
	"./Sem1_3.jpg": 2008,
	"./Sem2_1.jpg": 6857,
	"./Sem2_2.jpg": 4366,
	"./Sem2_3.jpg": 827,
	"./Sem2_4.jpg": 7992,
	"./Sem3_1.jpg": 7076,
	"./Sem3_2.jpg": 3139,
	"./Sem3_3.jpg": 3654,
	"./Sem4_1.jpg": 3443,
	"./Sem4_2.jpg": 8964,
	"./Sem4_3.jpg": 2689,
	"./Sem5_1.jpg": 6174,
	"./Sem5_2.jpg": 6233,
	"./Sem5_3.jpg": 4508,
	"./Sem5_4.jpg": 8855,
	"./Sem6_1.jpg": 2605,
	"./Sem6_2.jpg": 8450,
	"./Sem6_3.jpg": 4831,
	"./Spark1.JPG": 2419,
	"./Spark2.JPG": 2948,
	"./Spark3.JPG": 1518,
	"./hack1.jpg": 8918,
	"./hack2.jpg": 5617,
	"./hack3.jpg": 7572,
	"./hack4.jpg": 2511,
	"./ppt1.JPG": 4118,
	"./ppt2.JPG": 7009,
	"./ppt3.JPG": 7796,
	"./sih1.jpg": 8441,
	"./sih2.jpg": 2302,
	"./sih3.jpg": 8763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7638;